import React, { Component, Fragment } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import PropTypes from 'prop-types';
import TransitionChild from '../common/TransitionChild';
import '../../css/react-css-transitions.scss';
import withArticleTracking from '../common/withArticleTracking';

export class LinkCopierContainer extends Component {
  constructor() {
    super();
    this.state = {
      copied: false,
      utmTracker: '?utm_source=link_copy&utm_medium=referral',
    };
    this.handleCopy = this.handleCopy.bind(this);
  }

  handleCopy() {
    this.setState({
      copied: true,
    });
  }

  componentDidUpdate() {
    if (this.state.copied) {
      setTimeout(() => {
        this.setState({
          copied: false,
        });
      }, 3000);
    }
  }

  render() {
    const { copied, utmTracker } = this.state;
    const TrackedCopyToClipboard = withArticleTracking(CopyToClipboard);

    return (
      <Fragment>
        <TrackedCopyToClipboard
          text={typeof window !== 'undefined' ? window.location.href + utmTracker : ''}
          wrapperClassName="link-copier-container"
          onCopy={this.handleCopy}
          dataEventName="article_shared"
          actionType="clipboard"
          moduleName={this.props.module}
          component="link_copier">
          <div className="link-copier">
            <span className="icon-copy-link-black link-copier-icon" />
            <span className="link-copier-copy">Copy Link</span>
          </div>
        </TrackedCopyToClipboard>

        <ReactCSSTransitionGroup
          key="global-nav-overlay"
          transitionName="fade"
          transitionAppear={true}
          transitionAppearTimeout={250}
          transitionEnterTimeout={250}
          transitionLeaveTimeout={250}
          component={TransitionChild}>
          {copied
            && <div className="link-copier-success">
              <div className="link-copier-triangle"></div>
              <div className="link-copier-success-copy">
                Link was copied!
              </div>
            </div>
          }
        </ReactCSSTransitionGroup>
      </Fragment>
    );
  }
}

LinkCopierContainer.propTypes = {
  module: PropTypes.string,
};

export default LinkCopierContainer;
